import { formatDate } from "../utils/date_formatter";

export const capitalizeEachWord = (sentence: string | null | undefined) => {
  if (!sentence) {
    return "";
  }
  const trimmedSentence = sentence.trim();
  const capitalizeNonPrepositionWord = (word: string, index: number) => {
    if (index !== 0 && /^(?:of|on|at|in|to|by|against|with(?:in)?)$/i.test(word)) {
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
  };
  return trimmedSentence.split(/\s+/).map(capitalizeNonPrepositionWord).join(" ");
};

export const formatCountText = (count: number, word: string): string => {
  const pluralRules = new Intl.PluralRules("en-US");
  const pluralForm = pluralRules.select(count);
  return `${count} ${word}${pluralForm === "one" ? "" : "s"}`;
};

export const formatDateWithDefault = (value: unknown): string =>
  typeof value === "string" ? formatDate(value) || "—" : "—";
